package top.wcpe.allincore.ui.runtime.ir.prop

import top.wcpe.allincore.ui.runtime.element.UIElement
import top.wcpe.allincore.ui.runtime.internal.log.UiLog
import top.wcpe.allincore.ui.runtime.theme.ThemeLookup
import kotlin.jvm.JvmStatic

/**
 * 属性绑定注册表。
 */
object PropAppliers {

    private val LOGGER = UiLog("top.wcpe.allincore.ui.runtime.ir.prop.PropAppliers")

    private val REGISTRY: Map<String, PropBinding> = buildMap {
        LayoutPropContributor.contribute(this)
        VisualPropContributor.contribute(this)
        TransformPropContributor.contribute(this)
        ControlValuePropContributor.contribute(this)
        StructurePropContributor.contribute(this)
        SlotPropContributor.contribute(this)
        EntityPreviewPropContributor.contribute(this)
        ModelPreviewPropContributor.contribute(this)
        ModalPropContributor.contribute(this)
        ToastPropContributor.contribute(this)
        ButtonStatePropContributor.contribute(this)
        ControlVisualPropContributor.contribute(this)
        HotkeyPropContributor.contribute(this)
        EffectPropContributor.contribute(this)
        ComponentTokenPropContributor.contribute(this)
    }

    /** 入口：按 key 查表并调用对应 applier；未注册则 warning。 */
    @JvmStatic
    fun apply(el: UIElement<*>, key: String, v: Any?) {
        apply(el, key, v, null, null)
    }

    /** 入口：按 key 查表并调用对应 applier，带来源标签；未注册则 warning。 */
    @JvmStatic
    fun apply(el: UIElement<*>, key: String, v: Any?, label: String?) {
        apply(el, key, v, label, null)
    }

    /** 入口：带来源标签与主题 lookup（供 controlSize/textStyle 解析 token）。 */
    @JvmStatic
    fun apply(el: UIElement<*>, key: String, v: Any?, label: String?, themeLookup: ThemeLookup?) {
        val binding = REGISTRY[key]
        if (binding == null) {
            if (label != null) {
            }
            return
        }
        PropApplyContext.enter(label ?: "", themeLookup)
        try {
            binding.applier.apply(el, v)
            // FR-30 B4：任意属性变化都影响渲染（含纯视觉，如颜色/opacity），无条件标渲染脏。
            el.markRenderDirty()
            // FR-30 B1：影响布局的属性额外标布局脏，沿 parent 链上传触发增量重排。
            if (binding.affectsLayout) {
                el.markLayoutDirty()
            }
        } finally {
            PropApplyContext.exit()
        }
    }

    /** 读取属性当前值；未注册返回 null。 */
    @JvmStatic
    fun read(el: UIElement<*>, key: String): Any? = REGISTRY[key]?.read(el)
}
